import { z } from 'zod';

export const getRouteDefinitionsSchema = z.array(
  z.object({
    id: z.string(),
    isActive: z.boolean(),
    isFromManager: z.boolean(),
    name: z.string(),
    mwRouteTypeId: z.string(),
    mwUserTypeId: z.string(),
    mwSalesPersonTypeId: z.string().optional(),
    mwAccountGroupId: z.string(),
    allowWhenUnique: z.boolean().optional(),
    mwRouteType: z.object({ id: z.string(), name: z.string() }),
    mwSalesPersonType: z.object({ id: z.string(), name: z.string() }).optional(),
    mwAccountGroup: z.object({ id: z.string(), accountGroup: z.string() }),
    mwUserType: z.object({ id: z.string(), name: z.string() }),
  })
);

export type GetRouteDefinitionsResponse = z.infer<typeof getRouteDefinitionsSchema>;
